// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.guidance-helper[data-v-43198ff8] {\n\n    margin-bottom: 0.25rem;\n\n    padding-left: 0.5rem\n}\n.guidance-body[data-v-43198ff8] {\n\n    padding-left: 0px\n}\n.guidance-helper-floating[data-v-43198ff8] {\n\n    margin-top: 0.5rem;\n\n    margin-bottom: 0.5rem;\n\n    border-radius: 0.375rem;\n\n    border-width: 1px;\n\n    --tw-border-opacity: 1;\n\n    border-color: rgb(231 229 228 / var(--tw-border-opacity))\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
